import moment from 'moment'
import Numeral from 'numeral'

export const dateMonDayYearUTCTimeFull = timeStamp => {
  timeStamp = timeStamp.toString()
  const fixDateForAllBrowsers = timeStamp.replace(/-/g, '/')
  const removeUTCString = fixDateForAllBrowsers.replace(/\+0000 UTC/g, '')
  return moment.utc(removeUTCString).local().format()
}

export const dateMonDayYearTime = timeStamp => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
  const timezoneOffset = new Date().getTimezoneOffset()
  const timeSet = moment(timeStamp).utc(timeStamp)

  const checkFormat = moment(timeStamp).isValid()
  if (!checkFormat) {
    timeStamp = dateMonDayYearUTCTimeFull(timeStamp)
  }
  return moment(timeStamp).format('lll')
  // return moment(timeSet).utcOffset(timezoneOffset).format('lll')
}

export const dateMonDayYearTimeFull = timeStamp => {
  const checkFormat = moment(timeStamp).isValid()
  if (!checkFormat) {
    timeStamp = dateMonDayYearUTCTimeFull(timeStamp)
  }
  return moment(timeStamp).format('ll h:mm:ss A')
}

export const blockInvalidChar = e =>
  ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()

export const toFixedSpecial = (number, n) => {
  var str = number.toFixed(n)
  if (str.indexOf('e+') === -1) return str

  // if number is in scientific notation, pick (b)ase and (p)ower
  str = str
    .replace('.', '')
    .split('e+')
    .reduce(function (p, b) {
      return p + Array(b - p.length + 2).join(0)
    })

  if (n > 0) str += '.' + Array(n + 1).join(0)

  return str
}

export const formatNumber = number => {
  return number.replace(/[^0-9.]/g, '')
}

export const formatNumberWithComma = number => {
  return Numeral(number).format('0,0')
}

export const formatNumberWithCommaN2Decimal = number => {
  return Numeral(number).format('0,0.00')
}

export const formatNumberWithCommaN4Decimal = number => {
  return Numeral(number).format('0,0.0000')
}

export const dateUTCToObj = str => {
  const date = new Date(str),
    mnth = date.getUTCMonth() + 1,
    day = date.getUTCDate(),
    hours = date.getUTCHours(),
    minutes = date.getUTCMinutes()
  return {
    year: date.getFullYear(),
    month: Number(mnth),
    day: Number(day),
    hour: Number(hours),
    minute: Number(minutes),
  }
}
